// The name search of the Funerals page (PogrebiListComponent), shared so the home page and the
// "add message" popup suggest people the same way.

// Decode %-escapes, treat + as a space, trim.
export function normalizeSearchTerm(term) {
  if (term == null || String(term).trim() === "") return "";
  try {
    return decodeURIComponent(String(term)).replace(/\+/g, " ").trim();
  } catch {
    return String(term).replace(/\+/g, " ").trim();
  }
}

// True when the typed text starts the first name, starts the surname, or is part of "name surname".
export function matchesObituaryName(obituary, term) {
  const needle = normalizeSearchTerm(term).toLowerCase();
  if (!needle) return false;
  const first = (obituary.name ?? "").toLowerCase().trim();
  const last = (obituary.sirName ?? "").toLowerCase().trim();
  const full = `${first} ${last}`.trim();
  return (
    first.startsWith(needle) ||
    last.startsWith(needle) ||
    full.startsWith(needle) ||
    full.includes(needle)
  );
}
